//#region src/components/Notification/Notification.module.css
var e = "_wrapper_s6guw_1", t = "_inline_s6guw_8", n = "_container_s6guw_12", r = "_critical_s6guw_16", i = "_moderate_s6guw_21", a = "_info_s6guw_26", o = "_success_s6guw_31", s = "_header_s6guw_36", c = "_isCollapsed_s6guw_45", l = "_titleContainer_s6guw_49", u = "_chevronIcon_s6guw_54", d = "_actions_s6guw_63", f = {
	wrapper: e,
	inline: t,
	container: n,
	critical: r,
	moderate: i,
	info: a,
	success: o,
	header: s,
	isCollapsed: c,
	titleContainer: l,
	chevronIcon: u,
	actions: d
};
//#endregion
export { d as actions, u as chevronIcon, n as container, r as critical, f as default, s as header, a as info, t as inline, c as isCollapsed, i as moderate, o as success, l as titleContainer, e as wrapper };
